/**
 * @generated SignedSource<<15c613af7160fefd3f38ff1aff4cb0be>>
 * @relayHash 84a9c75863296610fb60639c2398b5f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f321b87f1a8e3715be97d9ac819a91c2907f9e50ea59fc606e85f9a1eb716608

import type { ConcreteRequest } from 'relay-runtime';
export type PageCommentEditorContentOperationsQuery$variables = {
  contentId: string;
  status?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type PageCommentEditorContentOperationsQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly space: {
        readonly id: string | null | undefined;
        readonly operations: ReadonlyArray<{
          readonly operation: string | null | undefined;
          readonly targetType: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type PageCommentEditorContentOperationsQuery = {
  response: PageCommentEditorContentOperationsQuery$data;
  variables: PageCommentEditorContentOperationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PageCommentEditorContentOperationsQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageCommentEditorContentOperationsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "84a9c75863296610fb60639c2398b5f3",
    "id": "f321b87f1a8e3715be97d9ac819a91c2907f9e50ea59fc606e85f9a1eb716608",
    "metadata": {},
    "name": "PageCommentEditorContentOperationsQuery",
    "operationKind": "query",
    "text": "query PageCommentEditorContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}}}"
  }
};
})();

(node as any).hash = "84986896d9e1b1e2bb0707f822adf359";

export default node;
